/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';


export interface PraticaEsercenteExportZipFilter { 
    stato?: Set<RichiestaPraticaEsercenteStatus>;
}

